import React, { Component } from "react";
import Layout from "../../../componentes/Comunes/Layout/Layout";
import PageHeading from "../../../componentes/Comunes/PageHeading";
import ParametrosConsultaSolicitud from "../../../componentes/Padron/ComponenteSolicitudesPadron/ParametrosConsultaSolicitud";

export class ConsultaSolicitudesPadron extends Component {

  render() {
    let parametros =
      this.props.location.state === undefined
        ? null
        : this.props.location.state.ParametrosCargados;
    return (
      <Layout>
        <div>
          <PageHeading title="Consulta de Solicitudes al Padrón" />
          <ParametrosConsultaSolicitud ParametrosCargados={parametros} />
        </div>
      </Layout>
    );
  }
}

export default ConsultaSolicitudesPadron;
